/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from "react";
import styles from "./StandardBoardsList.module.scss";
import arrowDown from "../../../../images/chevron-down.svg";
import arrowUp from "../../../../images/chevron-up.svg";
import pcba from "../../../../images/PCBA.svg";

const ListItem = (props: any): JSX.Element => {
  const { title, onRowItemClick, opened, label, icon, onEditClick, id, styleClass } = props;
  const imgSrc = opened ? arrowUp : arrowDown;
  return (
    <li id={id} className={styleClass}>
      <div
        className={styles.ListItemDiv}
        onClick={
          onRowItemClick
            ? () => onRowItemClick()
            : () => {
                /*  */
              }
        }
      >
        <div>
          {icon ? <img alt="pcba" src={pcba} width="20" /> : null}
          <span>
            {label ?? ""} {title}
          </span>
        </div>
        {opened !== undefined && <img alt="arrow" style={{ width: "15px" }} src={imgSrc} />}
        {onEditClick !== undefined && <button onClick={() => onEditClick()}>Edit</button>}
      </div>
      {props.children}
    </li>
  );
};

export default ListItem;
